import { map } from '../map/map';
import { getArea, getLength, getDistance } from 'ol/sphere';
import Overlay from 'ol/Overlay';
import Polygon from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import { unByKey } from 'ol/Observable';
import { drawSource, drawLayer } from './mapAssets';
import Select from 'ol/interaction/Select.js';
import {pointerMove} from 'ol/events/condition';

/**
 * Currently drawn feature.
 * @type {module:ol/Feature~Feature}
 */
let sketch;


/**
 * The help tooltip element.
 * @type {Element}
 */
let helpTooltipElement;


/**
 * Overlay to show the help messages.
 * @type {module:ol/Overlay}
 */
let helpTooltip;


/**
 * The measure tooltip element.
 * @type {Element}
 */
let measureTooltipActiveElement;


/**
 * Overlay to show the measurement.
 * @type {module:ol/Overlay}
 */
let measureTooltipActive;


/**
 * Message to show when the user is drawing a polygon.
 * @type {string}
 */
const continuePolygonMsg = 'Click to continue drawing the polygon';


/**
 * Message to show when the user is drawing a line.
 * @type {string}
 */
const continueLineMsg = window.displayText('RULER_CONTINUE_DRAWING_LINE');

/**
 * Reference all tooltips here, so it's possible to nahrenaze them later
 * @type {array}
 */
let allTooltips = [];
let tooltipFeatureMap = [];

let listener;

const formatLength = function(line) {
      const length = getLength(line);
      return formatLenString(length);
    };

const formatLenString = function(length) {
  
      let output;
      if (length > 100) {
        output = (Math.round(length / 1000 * 100) / 100).toFixed(2) +
            ' ' + 'km';
      } else {
        output = (Math.round(length * 100) / 100).toFixed(2) +
            ' ' + 'm';
      }
      
      return output;
}

      /**
       * Format area output.
       * @param {module:ol/geom/Polygon~Polygon} polygon The polygon.
       * @return {string} Formatted area.
       */
      const formatArea = function(polygon) {
        const area = getArea(polygon);
        let output;
        if (area > 10000) {
          output = (Math.round(area / 1000000 * 100) / 100).toFixed(2) +
              ' ' + 'km<sup>2</sup>';
        } else {
          output = (Math.round(area * 100) / 100).toFixed(2) +
              ' ' + 'm<sup>2</sup>';
        }
        return output;
      };


const drawStart = function(evt) {
    // set sketch
    sketch = evt.feature;

    /** @type {module:ol/coordinate~Coordinate|undefined} */
    let tooltipCoord = evt.coordinate;

    if(typeof measureTooltipActive === 'undefined') {

      measureTooltipActive = createActiveMeasureTooltip();
      measureTooltipActiveElement = measureTooltipActive.getElement();

      map.addOverlay(measureTooltipActive);
    }
    

    listener = sketch.getGeometry().on('change', function(evt) {
      const geom = evt.target;
      let output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
      }
      measureTooltipActiveElement.innerHTML = output;
      measureTooltipActive.setPosition(tooltipCoord);
    });
  };

var modifyFeaturesListeners = [];

  const modifyStart = function(evt) {
    // set sketch
    var modifyFeatures = evt.features.getArray();

    if(typeof measureTooltipActive === 'undefined') {

      measureTooltipActive = createActiveMeasureTooltip();
      measureTooltipActiveElement = measureTooltipActive.getElement();

      map.addOverlay(measureTooltipActive);
    }

    

    /** @type {module:ol/coordinate~Coordinate|undefined} */
    let tooltipCoord = evt.coordinate;

    for (var i = allTooltips.length - 1; i >= 0; i--) {
      if(allTooltips[i] === measureTooltipActive) {
        allTooltips[i].setPosition(null);
        map.removeOverlay(allTooltips[i]);
      }
    }

    for (var i = modifyFeatures.length - 1; i >= 0; i--) {

      var modifyFeature = modifyFeatures[i];

      modifyFeaturesListeners.push(modifyFeatures[i].getGeometry().on('change', function(evt, feature, val2) {
        
        for (var i = tooltipFeatureMap.length - 1; i >= 0; i--) {

          if(tooltipFeatureMap[i].feature == this) {

            clearMesureTooltips([tooltipFeatureMap[i].tooltip]);
          }
        }

        const geom = evt.target;
        let output;
        if (geom instanceof Polygon) {
          output = formatArea(geom);
          tooltipCoord = geom.getInteriorPoint().getCoordinates();
        } else if (geom instanceof LineString) {
          output = formatLength(geom);
          tooltipCoord = geom.getLastCoordinate();

          var coordinates = geom.clone().getCoordinates();
          
          const segmentDistance = [];

          var middleCoord = [0, 0]; 
          var n = 0;
          coordinates.map((coord, idx) => {
            n++;
            middleCoord[0] += parseInt(coord[0]);
            middleCoord[1] += parseInt(coord[1]);
          });

          

        }
        measureTooltipActiveElement.innerHTML = output;
        if (geom instanceof LineString) {
          measureTooltipActive.setPosition([(middleCoord[0]/n), (middleCoord[1]/n)]);
        } else {
          measureTooltipActive.setPosition(tooltipCoord);
        }
      }.bind(modifyFeature)));

    }

  };

const drawend = function(ev) {

            sketch = null;

          //  setAllMeasureTooltips(ev.feature);
            unByKey(listener);
            measureTooltipActive.setPosition(undefined);
          };

      const modifyEnd = function(ev) {

            // unset sketch
            sketch = null;


            for (var i = modifyFeaturesListeners.length - 1; i >= 0; i--) {
              unByKey(modifyFeaturesListeners[i]);
            }

         //   setAllMeasureTooltips(ev.feature);
            modifyFeaturesListeners = [];
            measureTooltipActive.setPosition(undefined);
          };

export const setAllMeasureTooltips = function(featuresToAdd) {

  clearMesureTooltips();
  var features = drawSource.getFeatures();;

  if(typeof featuresToAdd === 'object') {

  //  features = features.concat(featuresToAdd);
    features = [featuresToAdd];
  } else {

  }
  

  for (var i = features.length - 1; i >= 0; i--) {

    const geom = features[i].getGeometry();
    let output;
    let tooltipCoord;

    if (geom instanceof Polygon) {

      output = formatArea(geom);
      tooltipCoord = geom.getInteriorPoint().getCoordinates();

    } else if (geom instanceof LineString) {
      output = formatLength(geom);
      tooltipCoord = geom.getLastCoordinate();

      var coordinatesOrg = geom.clone().getCoordinates();
      var coordinates = geom.clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates();
      
      const segmentDistance = [];

      var middleCoord = [0, 0]; 
      var n = 0;
      coordinates.map((coord, idx) => {

        n++;
        middleCoord[0] += parseInt(coordinatesOrg[idx][0]);
        middleCoord[1] += parseInt(coordinatesOrg[idx][1]);

        if(typeof coordinates[idx-1] !== 'undefined') {


          if (coordinates.length<=2) return;

          var dist = getDistance(coord, coordinates[idx-1]);

          dist = formatLenString(dist);

          segmentDistance.push(dist);

          var measureTooltipSeg = createMeasureTooltip();
          tooltipFeatureMap.push({tooltip: measureTooltipSeg, feature: features[i]});
          measureTooltipSeg.getElement().innerHTML = "" + dist;
          allTooltips.push(measureTooltipSeg);

          var popupCoords = [
            (coordinatesOrg[idx-1][0] - (coordinatesOrg[idx-1][0] - coordinatesOrg[idx][0])/2),
            (coordinatesOrg[idx-1][1] - (coordinatesOrg[idx-1][1] - coordinatesOrg[idx][1])/2)
          ]

          measureTooltipSeg.setPosition(popupCoords);
        }
          

      });
    }

    var measureTooltip = createActiveMeasureTooltip();

    measureTooltip.getElement().innerHTML = output;

    if (geom instanceof Polygon) {
      measureTooltip.setPosition(tooltipCoord);
    } else {
      measureTooltip.setPosition([(middleCoord[0]/n), (middleCoord[1]/n)]);
    }
    
  //  measureTooltip.setPosition(coordinates[0]);


    allTooltips.push(measureTooltip);

   
    tooltipFeatureMap.push({tooltip: measureTooltip, feature: features[i]});
  }
}


export const clearMesureTooltips = function(specificTooltips){

  let allTooltipsToClear;

  if(typeof specificTooltips !== 'undefined') {

    allTooltipsToClear = specificTooltips;
  } else {

    allTooltipsToClear = allTooltips;
  }


  for (var i = allTooltipsToClear.length - 1; i >= 0; i--) {
    allTooltipsToClear[i].setPosition(null);
    var element = allTooltipsToClear[i].getElement();

    if (element && element.parentNode !== null) {

      element.parentNode.removeChild(element);
    }


    map.removeOverlay(allTooltipsToClear[i]);
  }

  if(specificTooltips === 'undefined') {
    allTooltips = [];
    tooltipFeatureMap = [];
  }

}

export const disableRulers = function() {

  clearMesureTooltips();

}


export const createActiveMeasureTooltip = function() {

    
    var measureTooltipElement = document.createElement('div');
    measureTooltipElement.className = 'tooltip tooltip-measure-active tooltip-measure-total';



    var measureTooltip = new Overlay({
      element: measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center'
    });
  
    map.addOverlay(measureTooltip);

    return measureTooltip;
  }

export const createMeasureTooltip = function() {

    
    var measureTooltipElement = document.createElement('div');
    measureTooltipElement.className = 'tooltip tooltip-measure';
    var measureTooltip = new Overlay({
      element: measureTooltipElement,
      offset: [0, -15],
      positioning: 'bottom-center'
    });
    allTooltips.push(measureTooltip);
    map.addOverlay(measureTooltip);

    return measureTooltip;
  }


map.getViewport().addEventListener('mouseout', function() {
     //   helpTooltipElement.classList.add('hidden');
      });

var modifyEnabled = false;

export const pointerMoveHandler = (ev) => {

  var bolFeatureSet = false;

  map.forEachFeatureAtPixel(ev.pixel, (feature, layer)=>{

      if(layer != drawLayer) {
        return;
      }

      const geom = feature.getGeometry();
      if (geom instanceof Point) {
        return;
      }

      if(typeof measureTooltipActive === 'undefined') {

        measureTooltipActive = createActiveMeasureTooltip();
        measureTooltipActiveElement = measureTooltipActive.getElement();

        map.addOverlay(measureTooltipActive);
      }

      let tooltipCoord;

      for (var i = tooltipFeatureMap.length - 1; i >= 0; i--) {

        if(tooltipFeatureMap[i].feature == this) {

          clearMesureTooltips([tooltipFeatureMap[i].tooltip]);
        }
      }

      
      let output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();

        measureTooltipActiveElement.innerHTML = output;
        measureTooltipActive.setPosition(tooltipCoord);

      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();

        //
        setAllMeasureTooltips(feature);
      }
    //  

      bolFeatureSet = true;
  });

  if(!bolFeatureSet && typeof measureTooltipActive !== 'undefined') {
     measureTooltipActive.setPosition(undefined);
     clearMesureTooltips();
  }
 
}

export const setRulerModifyEvents = function(ModifyInteraction) {

  if(!modifyEnabled) {
    
    ModifyInteraction.on("modifystart", modifyStart);
    ModifyInteraction.on("modifyend", modifyEnd);
    modifyEnabled = true;
  }
}

export const setRulerEvents = function(DrawInteraction, ModifyInteraction) {

  
  DrawInteraction.on("drawstart", drawStart);
  DrawInteraction.on("drawend", drawend);

}

export const unSetRulerEvents = function(DrawInteraction, ModifyInteraction) {

  
  DrawInteraction.un("drawStart", drawStart);
  DrawInteraction.un("drawend", drawend);

  setRulerModifyEvents();
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/draw/ruler.js